import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { rockHillConfig } from "./data";

export default function RockHillPage() {
  return <CityPageTemplate config={rockHillConfig} />;
}